// extracted by mini-css-extract-plugin
export default {"buttonDark":"Button_buttonDark__0XAON","buttonLight":"Button_buttonLight__z7PHh","btnPos":"Button_btnPos__Oq6jT","btnText":"Button_btnText__ekHnn"};